import {Fragment} from 'react';
import EventMaxWidthV4 from './EventMaxWidthV4';

interface IProps {
  className?: string;
  hasMaxWidth?: boolean;
}

export default function EventLineV4({className, hasMaxWidth}: IProps) {
  const Wrapper = hasMaxWidth ? EventMaxWidthV4 : Fragment;
  return (
    <Wrapper>
      <div className={cn('h-1 bg-white', className)} />
    </Wrapper>
  );
}
